
const fallLeagueRegistraion = [
  {
    link: "https://sixzerosixacademy.playbookapi.com/programs/more_info/class_package/77167/",
    name: "Mini Madness K to 2nd Grade",
    date: "Practice, and Games",
    time: "Tuesdays at 5PM",
    price: "Click to Learn More"
  },
  {
    link: "https://sixzerosixacademy.playbookapi.com/programs/more_info/class_package/77168/",
    name: "Not So Mini 3rd to 4th Grade",
    date: "Practice, and Games",
    time: "Thursdays at 5pm",
    price: "Click to Learn More"
  },
]


const why =[
"100% of our profits will be donated towards Gold Star Families",
"Travel-club quality training, without the travel club lifestyle.",
"your child gets the same caliber of coaching and skill development you’d find at any travel club. The difference is that it all happens one day a week. There are no weekend road trips, hotel bills, or schedules that take over your family’s life.",
"We believe great coaching shouldn’t be reserved for families who can afford high club fees. Our programs are built so that cost isn’t the barrier to a kid getting a real chance to grow.",
"606 Academy is a nonprofit led by a veteran, a minority partner, and a woman partner. Our leadership reflects the families we serve, and our mission is to give kids access, confidence, and a strong foundation, not just a place on a roster.",
"The bottom line: professional-quality training, a fair price, one day a week, from a team that’s invested in your child and your community.",

]

const goldstar = [
  "A Gold Star family is a family who has lost a loved one that died while serving in the U.S. armed forces",
  "Parents, spouses, children, and siblings of a fallen service member",
  "A Gold Star family carries a lifelong loss. The star marks the cost of service paid by the family as well as the service member."
]

const notes = [
  "If you can not attend evaluationsmyour child will be evaluated and placed on a team during the first praictice.",
  "Min 15 Kids, 3 Teams per division, 5 kids per team.",
  "Max 40 Kids, 8 Teams per division, 5 kids per team.",
]

const teams = [
  "The 3 on 3 League is an instructional and skill developmental for students in grades K-4. All skill levels are welcome. Athletes will participate in a 7 week program with one group evaluation session for team formation and one final week for playoffs. Players will be placed on teams according to skill level determined during evaluations of week one. While 606 Academy will do its best to accomodate buddy requests they are not guaranteed as our number one goal is to create balanced teams."
]

const evaluations = [
  "There will be one evaluation lasting 1 hour.",
  "Players will be assessed on skills through a series of formal drills followed by game play."
]

const kto2 = [
  "Dates - Mar 16 (Evaluation), 3/30/2027, 4/6/2027, 4/13/2027, 4/20/2027, 4/27/2027, 5/4/2027(PlayOffs)",
  "Games 6 to 7pm or 7 to 8pm",
  "Practices are run in a clinic style to allow each child the same opportunities to grow and greater opportunity for players to make friends on different teams.",
]

const threetoFour = [
  "Dates - Mar 18 (Evaluation), 4/1/2027, 4/8/2027, 4/15/2027, 4/22/2027, 4/29/2027, 5/6/2027(PlayOffs)",
  "Games 6 to 7pm or 7 to 8pm",
  "Practices are run in a clinic style to allow each child the same opportunities to grow and greater opportunity for players to make friends on different teams.",
]

const games = [
  "There will be 6 guaranteed games that will occur right after practice. The latest game time will be determined on how many total teams are registered to play. Parent volunteers will be needed to work the score clock and manage substititions. Games will have 2 halves (12:00 minutes per half) with a running clock stopping only during time-outs(1 per team) and the last minute of the game.",
  "Overtime will be the first team to score a basket wins."
]

const coaches = [
  "The league will be run by 606 Academy coaching staff however volunteer coaches are needed at all age levels and parents are strongly encouraged to assist with the program. Potential coaches should contact 606 Academy. Good sportsmanship and the ability to interact positively with youth are two key qualities of our volunteer basketball coaches."
]

const sportsmanship = [
  "Good sportsmanship is a top priority within 606 Academy for players, parents, and fans.",
  "606 Basketball Academy and game officials have complete authority to enforce good sportsmanship as necessary.",
  " If a coach or parent is ejected from a game they must immediately leave the gym and will be required to serve a one-game suspension.",
  " Staff may invoke further penalties should the situation warrant."
]

const gym = [
  "The park and/or the school district have allowed our basketball program to use their gyms. It is our responsibility -- as players, parents, and coaches -- to take care of the facilities.",
  "When in district facilities, players and other children should be supervised at all times. All participants are to remain in the gym unless they are using the restroom.",
  "Remember, we are guests in these facilities."
]

const uniforms = [
  "Players will recieve a two-color black and white reversible jersey with numbers on the front and back.", "All players must wear thier own dark colored shorts or sweatpants."
]

export {fallLeagueRegistraion, teams, notes, evaluations, kto2, threetoFour, games, coaches, sportsmanship, gym, uniforms, why, goldstar}